import { get } from './client.js';

export const search = (wsId, query, limit) => {
  const params = new URLSearchParams({ q: query });
  if (limit != null) params.set('limit', String(limit));
  return get(`/workspaces/${wsId}/crm-search?${params}`);
};
